import { useQuery } from "@tanstack/react-query";
import DataService from "../config/DataService";


const { getRequest } = DataService();


export const useGetAllCms = () => {
    return useQuery({
        queryKey: ["cms"],
        queryFn: () => {
            return getRequest(`/get_all_agent_cms`);

        },
    });
};


export const useGetMembersData = (token) => {
    return useQuery({
        queryKey: ["featured_users"],
        queryFn: () => {
            return getRequest(`/get_featured_users`);

        },
        enabled: !!token
    });
};




